export type Background = BackgroundColor | BackgroundImage | BackgroundGradient;

export enum BackgroundTypes {
    Color = 'color',
    Image = 'image',
    Gradient = 'gradient',
}

export interface BackgroundColor {
    id: number;
    color: string;
    type: BackgroundTypes.Color;
}

export interface BackgroundGradient {
    id: number;
    gradient: string;
    type: BackgroundTypes.Gradient;
}

export interface BackgroundImage {
    id: number;
    preview: string;
    url: string;
    type: BackgroundTypes.Image;
}
